import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { TextField } from '@mui/material';
export function FormikFieldText({ name, formikProps, ...props }) {
    const { handleChange, values, errors } = formikProps;
    return (_jsx(TextField, { name: name, value: values[name] || '', error: formikProps.getFieldMeta(name).touched && errors[name] ? true : false, helperText: formikProps.getFieldMeta(name).touched && errors[name] ? _jsx(_Fragment, { children: errors[name] }) : null, onChange: handleChange, ...props }));
}
